import { PlugZapIcon } from 'lucide-react';

import githubLogo from '@/assets/providers/github.svg';
import gitlabLogo from '@/assets/providers/gitlab.svg';
import jiraLogo from '@/assets/providers/jira.svg';
import ociRegistryLogo from '@/assets/providers/oci-registry.svg';
import { cn } from '@/lib/utils';

const LOGOS: Record<string, string> = {
  github: githubLogo,
  gitlab: gitlabLogo,
  jira: jiraLogo,
  oci_registry: ociRegistryLogo,
};

/**
 * A provider's mark, looked up by connection type; a generic plug for a type with no
 * logo yet. Decorative (the name sits beside it), so the image has an empty alt.
 * GitHub's mark is black, so it is inverted in dark mode.
 */
export function ProviderLogo({
  type,
  className,
}: {
  type: string;
  className?: string;
}) {
  const src = LOGOS[type];
  if (!src) {
    return (
      <PlugZapIcon
        aria-hidden="true"
        className={cn('text-muted-foreground size-6 shrink-0', className)}
      />
    );
  }
  return (
    <img
      src={src}
      alt=""
      width={24}
      height={24}
      className={cn(
        'size-6 shrink-0',
        type === 'github' && 'dark:invert',
        className,
      )}
    />
  );
}
